module.exports = {"pagination":{"ListQueues":{"result_key":"QueueUrls"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/sqs-2012-11-05.paginators.json
// module id = 480
// module chunks = 0